"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAccount = void 0;
const react_1 = require("react");
const functions_1 = require("../functions");
function useAccount() {
    const [account, setAccount] = (0, react_1.useState)(() => {
        return (0, functions_1.getAccount)();
    });
    (0, react_1.useEffect)(() => {
        const fetchAccount = () => {
            // console.log('TriaLogIn');
            const account = (0, functions_1.getAccount)();
            if (account) {
                setAccount(account);
                window.removeEventListener('TriaLogIn', fetchAccount);
            }
        };
        fetchAccount();
        // Add event listener for the custom storageChange event
        window.addEventListener('TriaLogIn', fetchAccount);
        // Clean up the event listener on component unmount
        return () => {
            window.removeEventListener('TriaLogIn', fetchAccount);
        };
    }, []);
    return { account };
}
exports.useAccount = useAccount;
